import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Optional,
  Output
} from '@angular/core';
import {
  MatDialogRef, MAT_DIALOG_DATA
} from '@angular/material/dialog';
import { TreeFormData } from '../../../data/models/interfaces/tree-form-data.interface';
import { TreeNode } from '../../../data/models/interfaces/tree-node.interface';


@Component({
  selector: 'app-tree-form',
  templateUrl: './tree-form.component.html',
  styleUrls: ['./tree-form.component.scss'],
})
export class TreeFormComponent implements OnInit {
  @Output() itemsOutput = new EventEmitter<TreeNode[]>();
  confirmEnable = false;

  treeDataInitial: TreeNode[] = []
  treeData: TreeNode[] = []
  title: string = 'Escolha o destinatário';
  searchPlaceHolder: string = 'Pesquise por um destinatário';

  constructor(
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    public data: TreeFormData,
    public readonly dialogRef: MatDialogRef<TreeFormComponent>
  ) {
    this.treeDataInitial = data.treeData;
    this.treeData = data.treeData;
    if (data.dialogTitle) this.title = data.dialogTitle;
    if (data.searchPlaceholder) this.searchPlaceHolder = data.searchPlaceholder;
  }

  ngOnInit(): void {
    this.confirmEnable = false;
  }

  enableConfirmButton(event: boolean) {
    this.confirmEnable = event;
  }

  backHome() {
    this.dialogRef.close(this.treeData);
  }

  confirmData() {
    this.dialogRef.close(this.treeData);
  }

  filter(value: any) {
    if (value == undefined || value == '') {
      if (this.treeData) {
        this.treeData = [];
        this.treeData.push(...this.treeDataInitial);
      }
    } else {
      const filterData: TreeNode[] = [];

      this.searchValue(filterData, this.treeDataInitial, value)

      this.treeData = [...new Set(filterData)];
    }
  }

  private searchValue(filter: TreeNode[], source: TreeNode[], value:string) {
    source.forEach((tree) => {
      tree.children?.forEach((child) => {
        if (child.parent?.name?.toLocaleLowerCase().includes(value)) {
          filter.push(child.parent);
        }
        if (child.name?.toLocaleLowerCase().includes(value)) {
          filter.push(child);
        }
        if (child.children) {
          this.searchValue(filter, child.children, value)
        }
      });
    });
  }
}
